<template>
  <div id="app1">
    
    <img src="https://www.directodo.com/Rentus/recursos/rentusLogo180.jpg" >

    <p center>{{version}}</p>
    <br>

    <div v-if="pase != 'vealo'">
    <br>
    <h2 class="title is-primary">Sistema de Control de rentas de inmuebles</h2>
    <button class="button" v-on:click="verComprar = !verComprar" v-if="!verComprar">Conocer mas</button>
    <button class="button" v-on:click="verComprar = !verComprar" v-if="verComprar" >Regresar</button>

    <br>
    <comprar-rentus v-if="verComprar"></comprar-rentus>
      <br>
      <br>
    
    <div v-if="!verComprar" id="vista2">
        <div style="background-color:Gainsboro">
          <br>
          <h3>Pagar renta o Comprar Sistema RENTUS</h3>
          <br>
          <p>
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank" >
                <input type="hidden" name="cmd" value="_s-xclick">
                <input type="hidden" name="hosted_button_id" value="296VWRSXHXA6J">
                <table align="center" border="1" >
                  <tr>
                      <td>
                          <input type="hidden" name="on0" value="Numero de contrato">Numero de contrato
                      </td>
                  </tr>
                  <tr>
                      <td>
                        <input type="text" name="os0" maxlength="200">
                      </td>
                  </tr>
                  <tr>
                    <td>
                      <input type="hidden" name="on1" value="Mi nombre" >Mi nombre
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input type="text" name="os1" maxlength="200" size="40px">
                    </td>
                  </tr>
                </table>
                <br>
                <input type="image" src="https://www.paypalobjects.com/es_XC/MX/i/btn/btn_paynowCC_LG.gif" border="0" name="submit" alt="PayPal, la forma más segura y rápida de pagar en línea.">
                <img alt="" border="0" src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif" width="1" height="1">
                <br>
              </form> 
                <button  v-on:click="emem()" class="button">Enviarme estado de cuenta a mi mail</button>
                <br>
                <button  v-on:click="licfun()" class="button">Documentos para la Licencia de Funcionamiento</button>

            </p>
            <br>
          </div>
          <br>
          <br>

          <form v-on:submit.prevent= 'checarUsuario'>
              <table align="center" >
                <tr>
                   <td align="left">Empresa</td>
                   <td><input type='empresa' required autofocus name='empresa' v-model='usuarios.empresa' ></td>
                </tr>
                <tr>
                   <td align="left">Mail </td>
                   <td><input type='email' required name='mail' v-model='usuarios.mail'></td>
                </tr>
                <tr>
                   <td align="left">Password </td>
                   <td><input type='password' required name='pase' v-model='usuarios.pasw'>  </td>
                </tr>
                <tr>
                    <td></td><td><input class = "button" type="submit" value="Entrar" ></td>
                </tr>
                <br>
              </table>        
          </form>
          <br>
          <br>
          
        </div>
    </div>

    <div v-if="cargando">Cargando ... <button class="button is-primary is-loading"></button></div>


    <div class="columns is-desktop is-gapless is-vcentered" v-if="pase == 'vealo' && !cargando">
        <div class="column"><router-link to="/pro">Propiedades</router-link></div>
        <div class="column"><router-link to="/inq">Inquilinos</router-link></div>
        <div class="column"><router-link to="/con">Contratos y Pre-Contratos</router-link></div>
        <div class="column"><router-link to="/mov">Movimientos</router-link></div>
        <div class="column"><router-link to="/usu">Usuarios</router-link></div>
        <div class="column"><router-link to="/pagos">Pagos</router-link></div>
        <div class="column"><router-link to="/rep">Reporteador</router-link></div>
    </div>
      
    <hr/>

    <router-view v-bind:vector='permisos' v-bind:elusuario='usuarios.mail' v-bind:empresa='usuarios.empresa'></router-view>
    
  </div>
</template>

<script>
import axios from 'axios';
import ComprarRentus from './Comprar-Rentus';

export default {
  name: 'app',
  components:{
      ComprarRentus
  },
  data () {
    return {
      usuarios:{
        mail: '',
        pasw: '',
        empresa: '1'
      },
      pase:'',
      permisos:'',
      verComprar: false,
      cargando: false,
      version: 'V 3.4'
    }  },
  methods:{
    hoy(){
        // regresa la fecha actual en formato YYYY-mm-dd
        var fech = new Date();
        var dia = fech.getDate();
        if(dia < 10) dia = '0' + dia;
        var mes = fech.getMonth() + 1;
        if(mes < 10) mes = '0' + mes;
        var año = fech.getFullYear();
        return año + '-' + mes + '-' + dia;
    },    
      checarUsuario(){
      var router = this.$router;

      axios.get('https://www.directodo.com/Rentus/accesosdb/checaUsuario2.php?elmail='+this.usuarios.mail + '&laClave=' + this.usuarios.pasw + '&laEmpresa=' + this.usuarios.empresa )
           .then((respuesta) => {
              if(respuesta){
                  var laRespuesta = respuesta.data;
                  if (laRespuesta.includes('sies')){
                    // autorizado
                    this.pase = 'vealo';
                    this.cargando = true;
                    // pasa el vector de permisos
                    var indice = laRespuesta.indexOf('*');
                    this.permisos = laRespuesta.substring(indice + 1);

                        // actualiza los cargos de rentas al día de hoy
                        axios.post('https://www.directodo.com/Rentus/accesosdb/agregaRentas.php?fa=' + this.hoy())
                          .then((respue) => {
                              if (respue){
                                // actualiza los saldos y fechas de saldos en el archivo propiedades

                                axios.post('https://www.directodo.com/Rentus/accesosdb/actualizaSaldos.php?fa=' + this.hoy())
                                  .then((respue) => {
                                    this.cargando = false;
                                    // alert('\n\n     Bienvenido\n     a RENTUS');
                                  })
                                  .catch((error) =>{
                                      alert('No se pudieron actualizar los saldos al día. Error: '+error);
                                  }
                                );
                              }
                          })
                          .catch((error) =>{
                              alert('No se pudieron actualizar las rentas al día. Error: '+error); 
                          }
                        );
                    // router.push('/location').catch(err => {})
                    router.push('/App');
                  }else{
                      alert("Usuario sin autorizacion");
                  }
              }else{
                  alert("El servidor no respondio con acceso");
                  return;
              }
          })
          .catch(error => {
              alert('No se puede accesar el servidor ' + error.message);
          });

    },
    
    emem(){
      // pide el contrato en caso de que sea usuario para pedir su edo de cuenta
      var cualContrato = prompt("\n\nContrato folio ?"); 
      // valida el contrato y el mail
      if (cualContrato <= 0 || cualContrato > 10000){
        alert("\n\n Ingrese su contrato y su mail que puso en su contrato por favor ");
        return;
      } 

      // pide el mail en caso de que sea usuario para pedir su edo de cuenta
      var cualMail = prompt("\n\nIngrese aqui el mail que puso en su contrato"); 
      // valida el contrato y el mail
      if (cualMail.length == 0 || !cualMail.includes('@')){
        alert("\n\n Falta el mail de su contrato");
        return;
      } 
      
      axios.post('https://www.directodo.com/Rentus/accesosdb/enviarEdoMail.php?edcpm=' + cualMail + '&ecde=' + cualContrato)
        .then((respue) => {
            if (respue.statusText == 'OK'){
                alert('\n\n     Estado de cuenta enviado a: \n     ' + cualMail);
            }
        })
        .catch((error) =>{
            alert('No se pudo enviar el estado de cuenta.  '+error);
        }
      );

    },

    licfun(){
      // pide el contrato en caso de que sea usuario para pedir su edo de cuenta
      var cualContrato2 = prompt("\n\nContrato folio ?"); 
      // valida el contrato y el mail
      if (cualContrato2 <= 0 || cualContrato2 > 10000){
        alert("\n\n Ingrese su contrato por favor ");
        return;
      } 

      // pide el mail en caso de que sea usuario para pedir su edo de cuenta
      var cualMail2 = prompt("\n\nIngrese aqui el mail de su contrato"); 
      // valida el contrato y el mail
      if (cualMail2.length == 0 || !cualMail2.includes('@')){
        alert("\n\n Falta el mail de su contrato");
        return;
      } 
      
      axios.post('https://www.directodo.com/Rentus/accesosdb/enviarDocLF.php?edcpm=' + cualMail2 + '&ecde=' + cualContrato2)
        .then((respue) => {
            if (respue.statusText == 'OK'){
                alert('\n\n     Estado de cuenta enviado a: \n     ' + cualMail2);
            }
        })
        .catch((error) =>{
            alert('No se pudo enviar el estado de cuenta.  '+error);
        }
      );

    }



  }

}

</script>

<style lang="scss">
    #app1 {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
    }

    h1, h2 {
      font-weight: normal;
    }

    ul {
      list-style-type: none;
      padding: 0;
    }

    li {
      display: inline-block;
      margin: 0 10px;
    }

    a {
      color: #42b983;
    }
</style>




// WEBPACK FOOTER //
// src/App.vue